import { isBoolean, pickBy } from 'lodash';
import { some } from './constants';
import dayjs from 'dayjs';

export function scrollTo(id: string, offsetTop: number) {
  const el = document.getElementById(id);
  if (el) {
    window.scrollTo({ top: el.offsetTop - offsetTop, behavior: 'smooth' });
  }
}

export const countActiveFilter = (filter: some, exception?: string[]): number => {
  const exceptionTmp = [
    'q',
    'pageSize',
    'pageIndex',
    'tab',
    'sort_by',
    'sort_order',
    ...(exception || []),
  ];
  const rs = Object.entries(filter).filter(([key, value]) => {
    if (exceptionTmp.includes(key)) {
      return false;
    }
    if (Array.isArray(value)) {
      if (value?.length > 0) {
        return true;
      }
      return false;
    }
    if (isBoolean(value)) {
      return true;
    }
    return !!value;
  })?.length;

  return rs;
};

export function titleCase(str) {
  str = str.toLowerCase().split(' ');
  for (let i = 0; i < str?.length; i++) {
    str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
  }
  return str.join(' ');
}

export function removeEmptyKeys(obj) {
  return pickBy(obj, (v) => v !== undefined && v !== null && v !== '');
}

export function mappedParamsRequest(obj) {
  return Object.entries(obj).reduce((acc, [key, value]: any) => {
    if (value && typeof value === 'object' && !Array.isArray(value) && value?.id) {
      acc[key] = value?.id;
    } else {
      acc[key] = value;
    }
    return acc;
  }, {});
}

export function dateFormatter(values) {
  if (!values) return '';
  return dayjs(values).format('DD/MM/YYYY');
}

/**
 * Formats ISO date string to dd/mm/yyyy without timezone conversion
 * @param value - ISO date string (e.g., "2025-12-04T14:38:29.000Z")
 * @returns Formatted date string (e.g., "04/12/2025")
 */
export function formatDateWithoutTimezone(value: string | number): string {
  if (!value) return '';
  const dateStr = value.toString().split('T')[0];
  const [year, month, day] = dateStr.split('-');
  return `${day}/${month}/${year}`;
}
